import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const menuItems = {
  super_admin: [
    { label: 'Dashboard',          path: '/dashboard',            icon: '🏠' },
    { label: 'Users',              path: '/users',                icon: '👥' },
    { label: 'Schedules',          path: '/schedules',            icon: '📅' },
    { label: 'Shifts',             path: '/shifts',               icon: '🕐' },
    { label: 'Remuneration',       path: '/remuneration/summary', icon: '💰' },
    { label: 'Reports',            path: '/reports',              icon: '📊' },
    { label: 'Assign System Admin',path: '/assign-system-admin',  icon: '🔐' },
  ],
  system_admin: [
    { label: 'Dashboard',    path: '/dashboard',            icon: '🏠' },
    { label: 'Users',        path: '/users',                icon: '👥' },
    { label: 'Schedules',    path: '/schedules',            icon: '📅' },
    { label: 'Shifts',       path: '/shifts',               icon: '🕐' },
    { label: 'Remuneration', path: '/remuneration/summary', icon: '💰' },
    { label: 'Reports',      path: '/reports',              icon: '📊' },
  ],
  tca: [
    { label: 'Dashboard', path: '/test-center', icon: '🏠' },
    { label: 'Schedules', path: '/schedules',   icon: '📅' },
    { label: 'Shifts',    path: '/shifts',       icon: '🕐' },
  ],
  invigilator: [
    { label: 'Dashboard',       path: '/invigilator',    icon: '🏠' },
    { label: 'My Shifts',       path: '/my-shifts',      icon: '🕐' },
    { label: 'My Remuneration', path: '/my-remuneration', icon: '💰' },
  ],
  attender: [
    { label: 'Dashboard', path: '/attender', icon: '🏠' },
  ],
};

const roleLabel = {
  super_admin:  'Super Admin',
  system_admin: 'System Admin',
  tca:          'TCA',
  invigilator:  'Invigilator',
  attender:     'Attender',
};

const roleIcon = {
  super_admin:  '👑',
  system_admin: '🛡️',
  tca:          '🎓',
  invigilator:  '👤',
  attender:     '🙋',
};

const Sidebar = () => {
  const { user, logout } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();
  const menus     = menuItems[user?.role] || [];

  return (
    <div style={{
      width: '230px',
      background: 'linear-gradient(180deg, #f1870e 0%, #e8650d 60%, #d45a0a 100%)',
      color: 'white',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: "'Segoe UI', sans-serif",
      boxShadow: '4px 0 20px rgba(241,135,14,0.25)',
      position: 'relative',
    }}>

      {/* Decorative background circles */}
      <div style={{
        position: 'absolute', top: '-40px', right: '-40px',
        width: '160px', height: '160px', borderRadius: '50%',
        backgroundColor: 'rgba(255,255,255,0.06)', pointerEvents: 'none'
      }} />
      <div style={{
        position: 'absolute', top: '60px', left: '-50px',
        width: '120px', height: '120px', borderRadius: '50%',
        backgroundColor: 'rgba(255,255,255,0.04)', pointerEvents: 'none'
      }} />

      {/* Navigation */}
      <nav style={{ flex: 1, padding: '12px 10px', overflowY: 'auto', paddingTop: '20px' }}>
        <div style={{
          fontSize: '10px', fontWeight: 700, color: 'rgba(255,255,255,0.55)',
          letterSpacing: '1px', textTransform: 'uppercase',
          padding: '4px 10px 10px',
        }}>
          Navigation
        </div>

        {menus.map((item) => {
          const isActive = location.pathname === item.path ||
            (item.path !== '/dashboard' &&
             item.path !== '/test-center' &&
             item.path !== '/invigilator' &&
             item.path !== '/attender' &&
             location.pathname.startsWith(item.path));
          return (
            <div
              key={item.path}
              onClick={() => navigate(item.path)}
              style={{
                padding: '11px 14px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                fontSize: '14px',
                fontWeight: isActive ? 700 : 500,
                borderRadius: '11px',
                marginBottom: '3px',
                backgroundColor: isActive ? 'rgba(255,255,255,0.22)' : 'transparent',
                color: 'white',
                border: isActive ? '1px solid rgba(255,255,255,0.3)' : '1px solid transparent',
                transition: 'all 0.15s ease',
                letterSpacing: '0.2px',
              }}
              onMouseEnter={e => {
                if (!isActive) e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.12)';
              }}
              onMouseLeave={e => {
                if (!isActive) e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              <span style={{
                fontSize: '16px',
                width: '22px', textAlign: 'center', flexShrink: 0,
              }}>
                {item.icon}
              </span>
              <span style={{ flex: 1 }}>{item.label}</span>
              {isActive && (
                <div style={{
                  width: '6px', height: '6px', borderRadius: '50%',
                  backgroundColor: 'white', flexShrink: 0,
                }} />
              )}
            </div>
          );
        })}
      </nav>

      {/* Logout */}
      <div style={{
        padding: '12px 10px',
        borderTop: '1px solid rgba(255,255,255,0.15)',
      }}>
        <div
          onClick={() => { logout(); navigate('/login'); }}
          style={{
            padding: '11px 14px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            fontSize: '14px',
            fontWeight: 600,
            borderRadius: '11px',
            color: 'rgba(255,255,255,0.9)',
            border: '1px solid transparent',
            transition: 'all 0.15s ease',
            letterSpacing: '0.2px',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.12)';
            e.currentTarget.style.color = 'white';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = 'rgba(255,255,255,0.9)';
          }}
        >
          <span style={{ fontSize: '16px', width: '22px', textAlign: 'center' }}>🚪</span>
          <span>Logout</span>
        </div>
      </div>

    </div>
  );
};

export default Sidebar;